module.exports = __webpack_public_path__ + "static/img/contant_7.a7c50a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_4/contant_7.jpg
// module id = JV33
// module chunks = 0